import { QueryClientStore } from './query-client.store';

export class PageClientStore extends QueryClientStore {
    constructor() {
        super('page');
    }
}
